module.exports = __webpack_public_path__ + "static/media/select_section_mobile_background.e606ade0.png";